module.exports = __webpack_public_path__ + "img/report_tx_icon.a18625ac.svg";